import InfoIcon from "@mui/icons-material/Info";
import { Link } from "@mui/material";
import React from "react";
import { generatePath } from "react-router-dom";

import { PATH_TICKETS } from "src/constants";
import { useUuid } from "src/hooks";
import { useBrand } from "src/hooks/useBrand";

import { DashboardHeadband } from "../DashboardHeadband";

export function NewTenantHeadband({ initialExpanded }: { initialExpanded?: boolean }) {
  const uuid = useUuid();
  const { identity } = useBrand();

  return (
    <DashboardHeadband ariaLabel="new-tenant" initialExpanded={initialExpanded}>
      <DashboardHeadband.Header>
        <DashboardHeadband.HeaderTitle>
          <InfoIcon sx={{ mr: 1 }} />
          L'accès aux paiements et à la comptabilité de votre compte n'est pas disponible
        </DashboardHeadband.HeaderTitle>
      </DashboardHeadband.Header>
      <DashboardHeadband.Details>
        Si vous êtes un nouveau client, elle s'activera à la prise d'effet de votre bail. Si le
        problème perdure ou pour toute demande de paiement d'ici cette activation,&nbsp;
        <Link href={`${generatePath(PATH_TICKETS, { uuid })}`}>
          contactez votre agence {identity.name}
        </Link>
        .
      </DashboardHeadband.Details>
    </DashboardHeadband>
  );
}
